module.exports = __webpack_public_path__ + "img/app_icon_84.69f1bd16.png";